import type { MultiMembershipsPromotion, Promotion } from '../Promotions.types'

export const isPromotionMembershipsMultiple = (
  promotion: Promotion,
): promotion is MultiMembershipsPromotion => promotion.type === 'MEMBERSHIPS_MULTI'
